import React, { useState, Suspense } from 'react';
import { FormContainer } from '../CreateForm.styles';
import { AuthCheckAdmin } from '../../../Utils/AuthCheck/AdminCheck.auth';
import HelmetHelper from '../../../Components/PageHelmet/HelmetHelper.component';
import NewsletterInputs from '../../../Components/NewsletterForm/NewsletterInputs.component';
const BreadCrumbs = React.lazy(
  () => import('../../../Components/Breadcrumbs/BreadcrumbsComponent.component')
);

const NewsletterSubmit = React.lazy(
  () => import('./NewsletterSubmit.component')
);

const CreateNewsletter = () => {
  const [news, setNews] = useState({
    mainTitle: '',
    month: '',
    title1: '',
    title2: '',
    title3: '',
    content1: '',
    content2: '',
    content3: '',
  });

  return (
    <>
      <AuthCheckAdmin>
        <HelmetHelper
          title="Create Newsletter"
          description="Form to create a newsletter"
        />
        <FormContainer>
          <Suspense fallback={<p>Loading breadcrumbs...</p>}>
            <BreadCrumbs
              one="Admin Dashboard"
              oneLink="/admin"
              two="Create Newsletter"
            />
          </Suspense>
          <h2>CREATE NEWSLETTER</h2>
          <form>
            <Suspense fallback={<p>Loading input fields...</p>}>
              <NewsletterInputs news={news} setNews={setNews} />
            </Suspense>
            <Suspense fallback={<p>Loading submit button...</p>}>
              <NewsletterSubmit news={news} />
            </Suspense>
          </form>
        </FormContainer>
      </AuthCheckAdmin>
    </>
  );
};

export default CreateNewsletter;
